





































import Vue from "vue";
import { Tutor } from "../types";
import TutorCard from "./TutorCard.vue";
import TutorCertification from "./TutorCertification.vue";
import TutorDisplayName from "./TutorDisplayName.vue";
import TutorHeadShot from "./TutorHeadShot.vue";
import axios from "axios";

export default Vue.extend({
  props: {
    tutor: {
      type: Object as () => Tutor,
      required: true
    }
  },

  watch: {
    "tutor.id": {
      immediate: true,
      handler() {
        this.loadSimilarTutors();
      }
    }
  },

  data() {
    return {
      similarTutors: [] as Tutor[]
    };
  },

  methods: {
    async loadSimilarTutors() {
      this.similarTutors = (
        await axios.get(`/ajax/tutors/${this.tutor.id}/similar`)
      )?.data?.data;
    }
  },

  components: {
    TutorCard,
    TutorCertification,
    TutorHeadShot,
    TutorDisplayName
  }
});
